/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosAnalyticsGeneralChartListInfo } from '../models/AptosAnalyticsGeneralChartListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AptosAnalyticsControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns AptosAnalyticsGeneralChartListInfo OK
     * @throws ApiError
     */
    public getGeneralChartData1({
        chartType,
        periodType = 'D7',
        stime,
        etime,
    }: {
        chartType: 'USER_TRX' | 'TPS_AVG' | 'PEAK_TPS' | 'ACTIVE_ACCOUNT_OF_DAY' | 'ACTIVE_ACCOUNT_OF_MONTH' | 'NEW_ACCOUNT' | 'GAS_CONSUMPTION' | 'GAS_UNIT_PRICE_AVG',
        periodType?: 'D7' | 'D30' | 'D90' | 'D180' | 'D365' | 'YTD' | 'ALL' | 'MANUAL',
        stime?: number,
        etime?: number,
    }): CancelablePromise<AptosAnalyticsGeneralChartListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/analytics/chart/general',
            query: {
                'chartType': chartType,
                'periodType': periodType,
                'stime': stime,
                'etime': etime,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public downloadGeneralChartCsv1({
        chartType,
        periodType = 'D7',
        stime,
        etime,
    }: {
        chartType: 'USER_TRX' | 'TPS_AVG' | 'PEAK_TPS' | 'ACTIVE_ACCOUNT_OF_DAY' | 'ACTIVE_ACCOUNT_OF_MONTH' | 'NEW_ACCOUNT' | 'GAS_CONSUMPTION' | 'GAS_UNIT_PRICE_AVG',
        periodType?: 'D7' | 'D30' | 'D90' | 'D180' | 'D365' | 'YTD' | 'ALL' | 'MANUAL',
        stime?: number,
        etime?: number,
    }): CancelablePromise<Array<string>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/aptos/analytics/chart/general/csv',
            query: {
                'chartType': chartType,
                'periodType': periodType,
                'stime': stime,
                'etime': etime,
            },
        });
    }

}
